import { render, staticRenderFns } from "./NewSelection.vue?vue&type=template&id=3497d814"
import script from "./NewSelection.vue?vue&type=script&lang=js"
export * from "./NewSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports